export default "__VITE_ASSET__d11bceec__"